/** @jsx jsx */

import bemify from 'bemify-js';
import { ReactNode } from 'react';
import { jsx, css } from '@emotion/core';

import { Button } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { getGuideStepIndexByKey } from 'app/cli-guide/utils';
import { DOCUMENTATION_URL, GUIDE_STEPS } from 'app/cli-guide/constants';

import './StepContent.scss';
import WizardFooter from '../WizardFooter';

const bem = bemify('step-content');

const Styles = {
  back: css`
    justify-self: flex-start !important;
  `,
  next: css`
    justify-self: flex-end !important;
  `,
};

type StepItem = {
  key: string;
  renderContent: () => ReactNode;
  nextButtonText: string;
};

type Props = {
  onClickBack: () => void;
  onClickNext: () => void;
  step: StepItem;
};

const defaultProps = { active: false, completed: false };

const StepContent = (props: Props) => {
  const { step, onClickBack, onClickNext } = props;

  const currentIndex = getGuideStepIndexByKey(step.key);
  const isFirstStep = currentIndex === 0;
  const isLastStep = currentIndex === GUIDE_STEPS.length + 1;
  const nextStep = isLastStep ? null : GUIDE_STEPS[currentIndex + 1];
  const nextHref = nextStep?.path ?? DOCUMENTATION_URL;

  return (
    <div className={bem()}>
      <div className={bem('__main')}>
        <section className={bem('__wrapper')}>{step.renderContent()}</section>
      </div>
      <WizardFooter>
        {!isFirstStep && (
          <span css={Styles.back}>
            <Link href={GUIDE_STEPS[currentIndex - 1].path}>
              <Button color="secondary" onClick={() => onClickBack()}>
                Back
              </Button>
            </Link>
          </span>
        )}
        <span css={Styles.next}>
          <Link color="secondary" href={nextHref}>
            <Button onClick={() => onClickNext()}>{step.nextButtonText}</Button>
          </Link>
        </span>
      </WizardFooter>
    </div>
  );
};

StepContent.defaultProps = defaultProps;

export default StepContent;
